import { apiClient } from '@/lib/apiClient';
import type { CmsListParams, CreateCmsPayload, UpdateCmsPayload } from '@/_types';

export async function getCmsList(params?: CmsListParams) {
  const res = await apiClient.get('/cms', { params });
  return res.data;
}

export async function getCmsEntry(id: string) {
  const res = await apiClient.get(`/cms/${id}`);
  return res.data;
}

export async function createCms(payload: CreateCmsPayload) {
  const res = await apiClient.post('/cms', payload);
  return res.data;
}

export async function updateCms(id: string, payload: UpdateCmsPayload) {
  const res = await apiClient.put(`/cms/${id}`, payload);
  return res.data;
}
